// Rutas de Vanguardia 360 (campañas). El router de la app las monta con una línea:
//   raiz.addChildren([inicio, ...rutasCampanas(raiz), tickets])
import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Bandeja } from "./Bandeja";
import { NuevaSolicitud } from "./NuevaSolicitud";
import { Solicitud } from "./Solicitud";
import { Ficha } from "./Ficha";
import { Calendario } from "./Calendario";
import { Historial } from "./Historial";
import { Avisos } from "./Avisos";

export function rutasCampanas<R extends AnyRoute>(raiz: R) {
  const padre = () => raiz;
  return [
    createRoute({ getParentRoute: padre, path: "/campanas", component: Bandeja }),
    createRoute({ getParentRoute: padre, path: "/campanas/nueva", component: NuevaSolicitud }),
    createRoute({ getParentRoute: padre, path: "/campanas/calendario", component: Calendario }),
    createRoute({ getParentRoute: padre, path: "/campanas/historial", component: Historial }),
    createRoute({ getParentRoute: padre, path: "/campanas/avisos", component: Avisos }),
    createRoute({ getParentRoute: padre, path: "/campanas/solicitudes/$id", component: Solicitud }),
    createRoute({ getParentRoute: padre, path: "/campanas/$id", component: Ficha }),
  ] as const;
}
